import styled from 'styled-components';

import { getDimension } from 'styled/helpers/getDimension';

export const Details = styled.div<{ strong?: boolean }>`
  font-size: ${props => props.theme.fontSize.xxs};
  margin-top: ${getDimension('size7')};

  ${({ theme }) => theme.breakpoints.down('sm')} {
    margin-top: ${getDimension('size4')};
  }
`;
